// extracted by mini-css-extract-plugin
export default {"warningPopUpBox":"EditTestDataObject_warningPopUpBox__DoqQl"};